import { render, staticRenderFns } from "./contact_header.vue?vue&type=template&id=10875131&"
import script from "./contact_header.vue?vue&type=script&setup=true&lang=ts&"
export * from "./contact_header.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./contact_header.vue?vue&type=style&index=0&id=10875131&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports